import React from "react";
import GeneralSettingsTab from "./GeneralTab";
import LightSettingsTab from "./LightSettingsTab";
import ThreeDInteractivityTab from "./ThreeDInteractivityTab";
import ViewPortTab from "./ViewportTab";
import useAppStore from "../../AppStore";

const TabBarRenderer = ({ activeTab, templateConfig, interactiveConfig }) => {
  const componentConfig = templateConfig.components.find(
    (e) => e.title === activeTab
  );

  switch (activeTab) {
    case "General":
      return (
        <GeneralSettingsTab
          componentConfig={componentConfig}
          templateConfig={templateConfig}
        />
      );
    case "3D Interactivity":
      return (
        <ThreeDInteractivityTab
          templateConfig={templateConfig}
          interactiveConfig={interactiveConfig}
        />
      );
    case "Viewport":
      return (
        <ViewPortTab
          componentConfig={componentConfig}
          updateAspectRatio={(value) =>
            useAppStore.getState().setAspectRatio(value)
          }
          aspectRatio={useAppStore.getState().aspectRatio}
        />
      );
    case "Lighting Settings":
      console.log("innn", componentConfig);
      return (
        componentConfig && (
          <LightSettingsTab
            templateConfig={templateConfig}
            componentConfig={componentConfig}
          />
        )
      );
    default:
      return null;
  }
};

export default TabBarRenderer;
